export const SPECIAL_CHARS           = '! @ # $ % ^ & *';
const specialCharsCondensed          = SPECIAL_CHARS.split(' ').join('');
export const SPECIAL_CHARS_CONDENSED = new RegExp(`[${ specialCharsCondensed }]`);
export const ALLOWED_CHARS_REGEXP    = /^[A-Za-z0-9!@#$%^&*]*$/;
export const PASSWORD_MIN_LENGTH     = 8;
